/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { CourierType } from '@well/courier-shared/domain';

export class ServiceProviderVoModel extends JSONable {
  uuid: string | undefined = undefined;
  name: string | undefined = undefined;
  legalEntityUuid: string | undefined = undefined;
  courierType: CourierType | undefined = undefined;
}
